import React, { useState, useEffect, Fragment } from "react";
import {
    StyleSheet, View, Text
} from "react-native";
import {v4 as uuidv4} from 'uuid';

import { FONT } from "../../../value/staticValues";
import { ERROR_CODE } from "../../../value/type";
import { PLATFORM_URL } from "../../../value/Url";
import { base64Encoding, getCurrentTimestamp, getTimestampToDate } from "../../../common/util";
import { requests } from "../../../common/RestAPI";
import { ValidationError } from "../../../common/ExceptionError";

import StepLine from "../../base/tamplate/StepLine";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import RadioListTable from "../../base/table/RadioListTable";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { CustomCircleCheckBox, CustomSquareCheckBox } from "../../base/CustomCheckBox";


import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as CheckRequestImg } from '../../../img/btn-radio-incon-check-inactive.svg';
import { ReactComponent as CheckImg } from '../../../img/btn-radio-incon-check-active.svg';

import { useTranslation } from "react-i18next";
import { AccountUuidParse } from "../../../interfaceTypes/AccountType";

interface ArgsType {
    storagePoolId: string;
    storagePoolDesc: string;
}

interface StorageUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
}

StorageUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function StorageUpdate(props:StorageUpdateProps) {
    const { t } = useTranslation();
    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);

    
    const [storagePoolDesc, setStoragePoolDesc] = useState(props.args?.storagePoolDesc || ' ');

    


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);

    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                setExecuteUpdateYn(true);
            }
            
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdateStorage();
        }
    }, [executeUpdateYn]);

    function executeResult(result, closeYn, infoMessage) {
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }
    
    function executeUpdateStorage() {
        const updatePackageData = {
                strg_pl_desc: storagePoolDesc,
        };
        
         
        requests.put(PLATFORM_URL.STORAGE_POOL + '/' + props.args?.storagePoolId, updatePackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }
    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("STORAGE_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea 
                                key={3} 
                                width={570} 
                                height={100} 
                                value={storagePoolDesc} 
                                type={"text"} 
                                activeYn={true}
                                inputCb={setStoragePoolDesc} 
                                warnYn={false} 
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                    </View>
                </View>
                :null 
            }
        </View>
    )
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },

    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    diskUsageText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowInfoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowStaticText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    dateText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    }
});

const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}